import { Component, OnInit, ElementRef, ViewChild, LOCALE_ID, OnDestroy } from "@angular/core";
import { MbscCalendarEvent, MbscDateType, MbscEventcalendarView, formatDate, localeHe as localeHeMobiscroll, MbscEventcalendarOptions, Notifications, MbscSelectData, MbscSelectedDateChangeEvent, MbscDatepickerOptions, MbscDatepicker, MbscPopup, MbscEventcalendar, MbscPopupOptions, MbscSelectOptions, MbscPopupButton } from "@mobiscroll/angular";
import { HttpServiceDiary } from "src/app/services/Diary/http/http.service_Diary";
import { Appointment, AppointmentCopyCutDelIn, AppointmentData, AppointmentDetails, AppointmentDetailsIn, AppointmentDetailsSummaryStep, AppointmentIn, CancelationReason, getEventStatus, InvalidResourceTime, NextSlotIn } from "src/classes/Diary/Appointment";
import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { Menu } from "primeng/menu";
import * as moment from "moment";
import { PopupItem } from "src/classes/Common/PopupItem";
import { environment, screenId } from "src/environments/environment";
import { Config, ConfigDiary } from "src/classes/Common/ConfigData";
import { MbscCalendarLabel } from "@mobiscroll/angular/dist/js/angular/shared/calendar-label";
import { ScreenSizeService } from "src/app/services/Common/screen-size/screen-size.service";
import { Subscription } from "rxjs";
import { SubscriberExploitation } from "src/classes/Diary/SubscriberExploitation";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { SmsForClient } from "src/classes/Automation/sms_setting";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { Worker } from "src/classes/Common/Worker";
import { registerLocaleData } from "@angular/common";
import localeHe from "@angular/common/locales/he";
import { CreateAppointmentComponent } from "../create-appointment/create-appointment.component";
import { CustomerAppointment } from "src/classes/Diary/CustomerAppointment";
import { Service } from "src/classes/Diary/DepartmentsServices";
import { take } from "rxjs/operators";
import io from "socket.io-client";
import { Control } from "src/classes/Authorization/BusinessRole";
import { HttpServiceAccount } from "src/app/services/Authorization/http/http.service_Account";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { DiaryStateService } from "src/app/services/diary-state/diary-state.service";

type Resource = {
    id: number;
    name: string;
    depth: number;
    isParent: boolean;
    description: string;
    imagePath: string;
    isShowMobile: boolean;
};

type OptEvent = MbscCalendarEvent & {
    job?: string;
    unscheduled?: boolean;
    firstName?: string;
    customerId?: number;
    isOffDay?: boolean;
    phoneNum2?: string;
    transactId?: number;
    hasComments?: boolean;
    resourceStream?: string;
    statusCall?: number;
    statusQueue?: number;
    birthDay?: number;
    birthMonth?: number;
    confStatus?: number;
    holidayName?: string;
    isBirthday?: boolean;
    shortName?: string;
    yomanId?: number;
    saparId?: number;
    prepayStatus?: number;
    statusAppointment?: number;
    isRepeatAppointment?: boolean;
    isCustIcon?: boolean;
    isExtAppId?: boolean;
    con?: string;
    subexp?: SubscriberExploitation[];
    iPath?: string;
    debt?: number;
    statusVal?: number; //status event copied
    offTimeType?: number;
    isManyApp?: boolean;
};

const calViewDayDefault: MbscEventcalendarView = {
    schedule: {
        type: "day",
        allDay: false,
        days: false,
        maxEventStack: "all",
    },
};

const calView4DaysDefault: MbscEventcalendarView = {
    schedule: {
        type: "day",
        size: 4,
        allDay: false,
        maxEventStack: "all",
    },
};

const calViewWeekDefault: MbscEventcalendarView = {
    schedule: {
        type: "week",
        allDay: false,
        maxEventStack: "all",
    },
};

enum MenuEnum {
    SeventhMenu = 7,
    EighthMenu = 8,
}

const today = new Date(new Date().setMinutes(59));
const myResources: Resource[] = [];
const beforeafterdays: number = 7;

const menuData = [
    { text: "עריכה", value: "edit", class: "edit-menu-item" }, //edit
    { text: "העתקה", value: "copy", class: "copy-menu-item" }, //copy
    { text: "גזירה", value: "cut", class: "cut-menu-item" }, //cut
    { text: "מחיקה", value: "delete", class: "delete-menu-item" }, //delete
];
const disabledMenu = [
    { text: "עריכה", value: "edit", class: "edit-menu-item disabled-menu-item" },
    { text: "הדבקה", value: "paste", class: "paste-menu-item" },
    { text: "גזירה", value: "cut", class: "cut-menu-item disabled-menu-item" },
    { text: "מחיקה", value: "delete", class: "delete-menu-item disabled-menu-item" },
];

registerLocaleData(localeHe, "he");

@Component({
    selector: "app-calendarview",
    templateUrl: "./calendarview.component.html",
    styleUrls: ["./calendarview.component.css"],
    providers: [Notifications, HttpServiceDiary, HttpService1, HttpServiceCustomer, { provide: LOCALE_ID, useValue: "he" }, MessageService],
})
export class CalendarviewComponent implements OnInit, OnDestroy {
    controls: Control[];

    resourceId: number;
    selectedWorkerName: string = "";
    selectedWorkerImagePath: string = "";
    workerfilter: boolean = false;
    mybResources: Resource[] = [];
    myeResources: MbscSelectData[];
    temporaryResources: Map<number, boolean> = new Map<number, boolean>();
    OptData: OptEvent[] = [];
    OptData_Supplemented: OptEvent[] = [];
    appointments_opt: Appointment[];
    invalid: InvalidResourceTime[] = [];
    getAppointmentsSubscription: Subscription;

    state: "loading" | "loaded" = "loading";

    items: ExtendedMenuItem[] = [];
    items_1: ExtendedMenuItem[];
    items_2: ExtendedMenuItem[];
    openedMenu: Menu;
    selectedMenuDate: MbscDateType;
    selectedMenuWorker: Resource;
    selectedWorkersCount: number = 0;
    isSelectedWorkersOverLimit: boolean = false;
    isNotSelectedWorkers: boolean = false;

    isCalendarHeaderMenuOpened: boolean = false;
    isCalendarMenuOpened: boolean = false;
    isWorkerSelectionOpened: boolean = false;
    isWorkerListOpened: boolean = false;
    isWorkerListModalOpened: boolean = false;

    appdet: AppointmentDetails = new AppointmentDetails();
    newAppData: AppointmentData = new AppointmentData();
    newAppDataHoliday: string;

    statusUpgradeEventText: string;

    answerPopupHeaderText: string = "";
    isAnswerConfirmPopupVisible: boolean = false;

    dw: number = 6;
    rangeValue: any = [];
    rangeText = "";

    calendarScrollTop = 0;
    savedScroll = 0;

    selectedDate: MbscDateType = new Date();
    refDate: MbscDateType = new Date();

    participants1: { [key: number]: boolean } = {};
    view: "day" | "4days" | "week" = "day";
    calView: MbscEventcalendarView = calViewDayDefault;

    //right click mouse
    isManyEvCustomer: boolean = false;
    clickDel: boolean = false;
    isAbsenceEvent: boolean = false;
    isRemovingAdditionalApp: boolean = false;
    reasonCancellationEv: string;

    cancellationReasons: CancelationReason[];

    absenceData = [];

    menuData = menuData;
    isMenuDisabled: boolean = false;
    selectValue: any;
    isMobileMenu: boolean = false;
    menuAnchor: any;
    appUpIn: AppointmentCopyCutDelIn = new AppointmentCopyCutDelIn();
    toDate: any = today;
    originDate: any = today;
    menuOpen = false;

    selectedEvent: MbscCalendarEvent;
    copiedEvent: MbscCalendarEvent;

    pastedDate: MbscDateType = new Date();

    pastedstartDate: MbscDateType = new Date();
    pastedendDate: MbscDateType = new Date();
    pastedResource: string | number;
    pastedColor?: string;
    pastedid?: number;

    action: string | undefined;

    detectAction(key: string) {
        console.log(key);
        switch (key) {
            /*       
                     case 'z': // undo
                       this.undoEvents();
                       break;
                   */
            case "delete": // delete
                if (!this.isMenuDisabled) {
                    this.deleteEvents();
                }
                break;
            case "paste": // paste
                this.pasteEvents();
                break;
            case "cut": // cut
                if (!this.isMenuDisabled) {
                    this.cutEvents();
                }
                break;
            case "copy": // copy
                this.copyEvents();
                break;
            case "edit": // edit
                //?this.calendarOptions.onEventClick()
                if (!this.isMenuDisabled) {
                    this.editEvent();
                }
                break;
        }
    }

    menuSettings: MbscSelectOptions = {
        touchUi: false,
        showInput: false,
        display: "anchored",
        buttons: [],
        onChange: (args: any) => {
            this.detectAction(args.value);
        },
        onClose: () => {
            this.menuOpen = false;

            // clear selection
            setTimeout(() => {
                this.selectValue = null;
            });
        },
    };

    //event click popup details
    tempEvent!: MbscCalendarEvent;
    deletedEvent!: OptEvent;
    // copiedEvent!: OptEvent;
    templstsub: SubscriberExploitation[] = [];
    isEditingEvent: boolean = false;
    selectedColor: string = "";
    popupHeaderText!: string;
    popupAnchor: HTMLElement | undefined;
    popupButtons: any = [];
    infoCardPopupOptions: MbscPopupOptions = {
        responsive: {
            medium: {
                display: "anchored",
                fullScreen: false,
                touchUi: false,
                width: "524px",
                maxHeight: "608px",
            },
        },
        display: "top",
        fullScreen: true,
        touchUi: true,
        contentPadding: false,
        focusOnClose: false,
        showArrow: true,
        scrollLock: false,
        maxWidth: "100%",
        maxHeight: "100%",
    };

    popupOptions: MbscPopupOptions = {
        responsive: {
            medium: {
                display: "anchored",
                fullScreen: false,
                touchUi: false,
                width: "524px",
                maxHeight: "608px",
            },
        },
        display: "top",
        fullScreen: true,
        touchUi: true,
        contentPadding: false,
        focusOnClose: false,
        showArrow: true,
        scrollLock: false,
        maxWidth: "100%",
        maxHeight: "100%",
    };

    popupNewEventOptions: MbscPopupOptions = {
        responsive: {
            medium: {
                display: "anchored",
                fullScreen: false,
                touchUi: false,
                width: "742px",
                height: "100%",
                maxHeight: "904px",
            },
        },
        display: "top",
        fullScreen: true,
        touchUi: true,
        contentPadding: false,
        focusOnClose: false,
        closeOnOverlayClick: false,
        scrollLock: false,
        maxWidth: "100%",
        maxHeight: "100%",
        onClose: () => {
            if (!this.isEditingEvent) {
                // refresh the list, if add popup was canceled, to remove the temporary event
                // this.OptData = [...this.OptData];
                this.OptData = this.OptData.filter((event: OptEvent) => event !== this.tempEvent);
            }

            this.isEditingEvent = false;
        },
    };

    @ViewChild("calendar", { static: false }) calendar!: MbscEventcalendar;
    @ViewChild("infoCardPopup", { static: false }) infoCardPopup!: MbscPopup;
    @ViewChild("popupanswer", { static: false }) popupAnswer!: MbscPopup;
    @ViewChild("newEventPopup", { static: false }) newEventPopup!: MbscPopup;
    @ViewChild(CreateAppointmentComponent, { static: false }) createAppointmentComponent: CreateAppointmentComponent;

    @ViewChild("menuright", { static: false }) menuRight!: any;

    config: Config = new Config();

    popupEventTitle: string | undefined;
    infoCardPopupEventDescription = "";
    infoCardPopupEventAllDay = true;
    infoCardPopupIpath!: string;
    infoCardPopupEventDates: any;
    infoCardPopupEventDuration: string;
    infoCardPopupEventDate: string;
    infoCardPopupEventResource: string;
    infoCardPopupEventStatus = "busy";
    infoCardPopupEventJobs: string[];
    infoCardPopupIsBirthday: boolean;
    infoCardPopupOffTimeType: number;
    infoCardPopupComment: string;
    infoCardPopupEvent: MbscCalendarEvent = null;
    switchLabel: string = "All-day";

    // newCardPopupEventDates: any;
    newCardPopupEventDate: string;
    newCardPopupEventResource: number;
    // newCardPopupEventDuration: string;
    newCardPopupEventInvalidTime: InvalidResourceTime[];

    popupUpgradeButtons: MbscPopupButton[] = [
        // "cancel",
        {
            handler: () => {
                this.closeUpgradeEventPopup();
            },
            keyCode: "esc",
            text: "יציה",
            cssClass: "mbsc-popup-button-primary",
        },
    ];

    popupAddButtons: MbscPopupButton[] = [
        // "cancel",
        {
            handler: () => {
                this.closeNewEventPopup();
            },
            keyCode: "esc",
            text: "יציה",
            cssClass: "mbsc-popup-button-primary",
        },

        /*   {
              handler: () => {
                  this.saveNewEvent();
              },
              keyCode: "enter",
              text: "שמירה",
              cssClass: "mbsc-popup-button-primary",
          }, */
    ];

    configDiary: ConfigDiary = new ConfigDiary();

    options: MbscEventcalendarOptions = {
        locale: localeHeMobiscroll,
        theme: "windows",
        themeVariant: "light",
    };

    calendarOptions: MbscEventcalendarOptions = {
        locale: localeHeMobiscroll,
        theme: "windows",
        themeVariant: "light",
        // remove "double" to implement custom double click handling
        clickToCreate: false,
        dragToCreate: false,

        // dragToCreate: true on desktop (remove to implement custom double click handling)
        // responsive: {
        //     "large": {
        //         dragToCreate: true
        //     }
        // },

        onPageLoading: (args) => {
            this.toDate = args.month;
        },
        onEventClick: (args) => {
            console.log(this.ignoreNextEventClick);
            // Ignore the first event click immediately after creating a new event
            if (this.ignoreNextEventClick) {
                this.ignoreNextEventClick = false;
                return;
            }

            if (!args.event.allDay && !this.isLongPressing) {
                this.isEditingEvent = true;
                if (args.event.subexp && args.event.subexp.length > 0) {
                    const splitted = args.event.job.split(",");

                    this.templstsub = args.event.subexp;
                    for (let i = 0; i < this.templstsub.length; i++) {
                        this.templstsub[i].servicename = splitted[i];
                    }
                }

                // fill popup form with event data
                this.loadPopupForm(args.event);
                // this.selectedColor = args.event.color || this.mybResources.find((r) => r.id === args.event.resource)!.color;
                // set popup options
                this.popupAnchor = args.domEvent.currentTarget;
                this.infoCardPopupEvent = args.event;
                this.infoCardPopupOffTimeType = this.appointments_opt.find((x) => x.yomanId == args.event.id).offTimeType;

                this.infoCardPopupEventJobs = this.infoCardPopupEvent.job.split(",");

                if (this.infoCardPopupEvent.birthMonth && this.infoCardPopupEvent.birthMonth.toString().length == 1) {
                    this.infoCardPopupEvent.birthMonth = "0" + this.infoCardPopupEvent.birthMonth;
                }

                if (this.infoCardPopupEvent.birthDay && this.infoCardPopupEvent.birthDay.toString().length == 1) {
                    this.infoCardPopupEvent.birthDay = "0" + this.infoCardPopupEvent.birthDay;
                }

                this.infoCardPopupIsBirthday = this.infoCardPopupEvent.birthDay && this.infoCardPopupEvent.birthMonth && (this.selectedDate as Date).getDate() == this.infoCardPopupEvent.birthDay && (this.selectedDate as Date).getMonth() + 1 == this.infoCardPopupEvent.birthMonth;

                //getting the name of the holiday
                const allDayEvent = this.OptData.find((event: OptEvent) => event.id === -9999 && (event.start as Date).getDate() == (args.event.start as Date).getDate());
                if (allDayEvent) {
                    this.infoCardPopupEvent.holidayName = allDayEvent.holidayName;
                }

                this.onGetInfoClick(args.event);

                // open the popup
                this.infoCardPopup.open();
            }
        },
        // onEventCreated: (args) => {
        //     setTimeout(async () => {
        //         this.isEditingEvent = false;
        //         this.tempEvent = args.event;
        //         this.popupAnchor = args.target;

        //         // fill popup form with event data
        //         await this.loadPopupFormNewEvent(args.event);

        //         this.createAppointmentComponent.initialize();

        //         // open the popup
        //         this.newEventPopup.open();
        //     }, 0);
        // },
        onEventRightClick: (args) => {
            this.selectedEvent = [args.event];

            this.pastedendDate = [args.event.end];
            this.pastedstartDate = [args.event.start];
            let stc = [args.event.color];
            this.pastedColor = stc.toString();

            args.domEvent.preventDefault();
            this.menuData = menuData;
            this.isMenuDisabled = false;
            this.menuAnchor = args.domEvent.target;
            setTimeout(() => {
                this.menuRight.open();
            });
            this.clickDel = false;
            this.isManyEvCustomer = false;
            this.isAbsenceEvent = false;
            this.menuOpen = true;
        },
        onCellRightClick: (args) => {
            if (!this.menuOpen && this.copiedEvent !== undefined && this.copiedEvent !== null) {
                args.domEvent.preventDefault();
                this.menuData = disabledMenu;
                this.isMenuDisabled = true;
                this.menuAnchor = args.domEvent.target;
                this.pastedDate = args.date;
                this.pastedResource = args.resource;

                setTimeout(() => {
                    this.menuRight.open();
                });
            }
        },
        // Double click handling
        onCellClick: async (args) => {
            if (this.clickTimeout && this.firstClickTarget === args.target) {
                clearTimeout(this.clickTimeout);
                this.clickTimeout = null;
                this.firstClickTarget = null;

                const newEvent: OptEvent = {
                    allDay: false,
                    end: moment(args.date).add(this.configDiary.calScaleInMin, "minutes").toDate(),
                    id: -1,
                    resource: args.resource,
                    slot: undefined,
                    start: args.date,
                    title: "New Appointment",
                };

                this.OptData.push(newEvent);
                this.OptData = [...this.OptData];

                // Set the flag after creating the event so a following click (quick triple-click) is ignored by onEventClick
                this.ignoreNextEventClick = true;

                this.isEditingEvent = false;
                this.tempEvent = newEvent;
                this.popupAnchor = args.target;

                // fill popup form with event data
                await this.loadPopupFormNewEvent(newEvent);

                this.createAppointmentComponent.initialize();

                // Prevent onEventClick from reacting to the immediate click (triple-click problem).
                setTimeout(() => (this.ignoreNextEventClick = false), 600);

                // open the popup
                this.newEventPopup.open();
            } else {
                this.firstClickTarget = args.target;
                this.clickTimeout = setTimeout(() => {
                    this.clickTimeout = null;
                    this.firstClickTarget = null;
                }, 500);
            }
        },
        /*           onEventDeleted: (args) => {
                    setTimeout(() => {
                      this.deleteEvent(args.event);
                    });
                  }, */
    };

    // Click timeout for handling double click events
    clickTimeout: any = null;
    firstClickTarget: HTMLElement | null = null;

    // Long press detection
    isLongPressing: boolean = false;
    // When true, the next event click will be ignored (used to prevent a triple-click)
    ignoreNextEventClick: boolean = false;

    // options for datepicker in the week mode
    datepickerWeekOptions: MbscDatepickerOptions = {
        locale: localeHeMobiscroll,
        theme: "windows",
        themeVariant: "light",
        cssClass: "custom-week-mbsc-datepicker custom-mbsc-datepicker",
    };

    // options for datepicker in the day and 4days mode
    datepickerDayOptions: MbscDatepickerOptions = {
        locale: localeHeMobiscroll,
        theme: "windows",
        themeVariant: "light",
        cssClass: "custom-day-mbsc-datepicker custom-mbsc-datepicker",
    };

    datepickerLabels: MbscCalendarLabel[] = [];

    // button in datepicker that sets today`s date
    nowButton = {
        cssClass: "custom-datepicker-now-button",
        text: "חזור להיום",
        handler: () => {
            this.selectedDate = new Date();
            this.refDate = this.selectedDate;
            this.closeDatepicker();
        },
    };

    sms: SmsForClient = new SmsForClient();
    receivedsms: SmsForClient = new SmsForClient();
    isDialogVisible: boolean = false;
    isDialogErrorVisible: boolean = false;
    currentCustomerId: number;
    currentCustomerPhone: string;
    smsText: string = "";

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    @ViewChild("smsInput", { static: false }) smsInput: ElementRef<HTMLInputElement>;

    isModeSelectOpened: boolean = false;
    modeSelectItems: ExtendedMenuItem[];
    modeSelectItemSelected: number = 0;

    formatDate: (format: string, date: Date | MbscDateType) => string = formatDate;

    @ViewChild("mobileDatepicker", { static: false }) mobileDatepicker: MbscDatepicker;
    @ViewChild("desktopDatepicker", { static: false }) desktopDatepicker: MbscDatepicker;

    socket: any;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private httpService: HttpServiceDiary,
        private logger: NGXLogger,
        private screenSizeService: ScreenSizeService,
        private notify: Notifications,
        private httpService1: HttpService1,
        private httpServiceAccount: HttpServiceAccount,
        private messageService: MessageService,
        private router: Router,
        private diaryStateService: DiaryStateService,
    ) {
        //saving and restoring calendar state
        // this.router.events.subscribe((event) => {
        //     if (event instanceof NavigationStart) {
        //         if (this.router.url.includes("/diary")) {
        //             this.saveScroll();
        //         }
        //     }
        //     if (event instanceof NavigationEnd) {
        //         if (this.router.url.includes("/diary")) {
        //             setTimeout(() => {
        //                 this.restoreScroll();
        //             }, 700);
        //         }
        //     }
        // });
    }

    ngOnInit(): void {
        this.view = this.diaryStateService.viewType;

        this.selectedDate = this.diaryStateService.selectedDate;
        this.refDate = this.diaryStateService.selectedDate;

        if (this.diaryStateService.selectedWorker) {
            this.resourceId = this.diaryStateService.selectedWorker.value;
            this.selectedWorkerName = this.diaryStateService.selectedWorker.text;
            this.selectedWorkerImagePath = this.diaryStateService.selectedWorker.imagePath;
        }

        this.getResources();
        this.handleClickAppointments();

        // Get business configuration
        this.httpServiceCustomer.getConfig().subscribe(
            (data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
            },
        );

        // Get the list of control states
        this.httpServiceAccount.getControlsByScreen({ screen_id: screenId.Calendar.calendarview }).subscribe(
            (res: [Control]) => {
                console.log(res);
                this.controls = res;

                // Get the list of items in popup
                this.httpService.getItemsMenuByScreen({ screen_id: screenId.Calendar.calendarview }).subscribe(
                    (res: [PopupItem]) => {
                        console.log(res);
                        let m: ExtendedMenuItem[] = [];
                        res.forEach((item) => {
                            const menuItem: ExtendedMenuItem = {
                                label: item.mn_menuitem_title,
                                icon: item.mn_icon.split(".svg")[0],
                                id: item.mn_id.toString(),
                                menu_Id: item.mn_menu_id,
                                disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                                command: () => this.menuItemCommand(item.mn_menu_id, item.mn_order_id),
                            };
                            m.push(menuItem);
                        });

                        this.items = m;
                        this.items_2 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.EighthMenu);

                        this.updateFirstMenuItems(this.view);
                    },
                    (error) => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    },
                );
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );

        this.httpService.getCancelationReasons().subscribe(
            (data: CancelationReason[]): void => {
                this.cancellationReasons = [...data];
                console.log("Count of cancellationReasons for business: " + this.cancellationReasons.length);

                this.cancellationReasons.map((i) => {
                    this.absenceData.push({
                        text: i.cancelReason,
                        value: i.cancelReasonID,
                    });
                });
                this.reasonCancellationEv = this.absenceData[0].text;
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );

        // Get calendar configuration
        setTimeout(() => {
            this.httpService.getConfigDiary().subscribe(
                (data: ConfigDiary) => {
                    this.configDiary = data;

                    document.documentElement.style.setProperty("--calendar-cell-height", this.configDiary.calRowHeight + "px");

                    calViewDayDefault.schedule.timeCellStep = this.configDiary.calScaleInMin;
                    calViewDayDefault.schedule.timeLabelStep = this.configDiary.calScaleInMin;
                    calViewDayDefault.schedule.startTime = this.configDiary.fromHour;
                    calViewDayDefault.schedule.endTime = this.configDiary.toHour;
                    calView4DaysDefault.schedule.timeCellStep = this.configDiary.calScaleInMin;
                    calView4DaysDefault.schedule.timeLabelStep = this.configDiary.calScaleInMin;
                    calView4DaysDefault.schedule.startTime = this.configDiary.fromHour;
                    calView4DaysDefault.schedule.endTime = this.configDiary.toHour;
                    calViewWeekDefault.schedule.timeCellStep = this.configDiary.calScaleInMin;
                    calViewWeekDefault.schedule.timeLabelStep = this.configDiary.calScaleInMin;
                    calViewWeekDefault.schedule.startTime = this.configDiary.fromHour;
                    calViewWeekDefault.schedule.endTime = this.configDiary.toHour;

                    // switch (this.configDiary.calView) {
                    //     case 1: {
                    //         this.view = "day";
                    //         break;
                    //     }
                    //     case 2: {
                    //         this.view = "4days";
                    //         break;
                    //     }
                    //     case 3: {
                    //         this.view = "week";
                    //         break;
                    //     }
                    // }

                    this.changeView(false, false);

                    if (this.configDiary.isISocket) {
                        // Connect to socket
                        this.socket = io(environment.urlsocketio, {
                            transports: ["websocket"],
                            query: {
                                businessId: this.config.remotebusid,
                            },
                        });

                        // Listen to socket events
                        // Get events for the selected date when new appointment is created or updated by another user
                        this.socket.on("newAppointment", (data: any) => {
                            console.log(data);
                            // Use getSocketEventDate to determine the date for which events should be fetched, based on the event data and the current view
                            this.handleClickAppointmentsSupplemented(this.getSocketEventDate(data));
                        });

                        // Get events for the selected date when an appointment is pasted by another user
                        this.socket.on("pasteAppointment", (data: any) => {
                            console.log(data);
                            // Use getSocketEventDate to determine the date for which events should be fetched, based on the event data and the current view
                            this.handleClickAppointmentsSupplemented(this.getSocketEventDate(data));
                        });

                        // Get events for the selected date when an appointment is deleted by another user
                        this.socket.on("deleteAppointment", (data: any) => {
                            console.log(data);
                            // Use getSocketEventDate to determine the date for which events should be fetched, based on the event data and the current view
                            this.handleClickAppointmentsSupplemented(this.getSocketEventDate(data));
                        });
                    }

                    // this.config.switchViewPlan = 1;
                    console.log(this.configDiary);
                },
                (error) => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
                },
            );
        }, 0);

        this.modeSelectItems = [
            {
                label: "מעבר ליומן יומי",
                icon: "1day-calendar",
                menu_Id: 0,
                command: () => {
                    this.isModeSelectOpened = false;
                    this.modeSelectItemSelected = 0;
                    this.view = "day";
                    this.changeView();
                },
            },
            {
                label: "מעבר ליומן 4 ימים",
                icon: "4days-calendar",
                menu_Id: 1,
                command: () => {
                    this.isModeSelectOpened = false;
                    this.modeSelectItemSelected = 1;
                    this.view = "4days";
                    this.changeView();
                },
            },
            {
                label: "מעבר ליומן שבועי",
                icon: "7days-calendar",
                menu_Id: 2,
                command: () => {
                    this.isModeSelectOpened = false;
                    this.modeSelectItemSelected = 2;
                    this.view = "week";
                    this.changeView();
                },
            },
        ];

        this.isMobileMenu = this.screenSizeService.getScreenWidth() < 575;

        this.infoCardPopupEvent = {};
        // event listener that hides mobile components on resizing
        window.addEventListener("resize", () => {
            if (this.screenSizeService.getScreenWidth() > 991) {
                this.isWorkerSelectionOpened = false;
                this.isModeSelectOpened = false;
                this.isWorkerListOpened = false;
                this.isWorkerListModalOpened = false;
                this.isCalendarMenuOpened = false;
                this.closeDatepicker();
                if (this.view == "day" && this.mybResources.length < myResources.length) {
                    this.mybResources = myResources;
                    this.selectedWorkersCount = this.myeResources.length;
                }
            }

            if (this.screenSizeService.getScreenWidth() <= 991) {
                // mode condition, if the view is day, then events will be filtered by selected workers, if the view is week or 4 days, then selected one will be shown
                if (this.view == "day") {
                    this.mybResources = myResources.filter((resource: Resource) => {
                        return this.myeResources.find((tempResource: MbscSelectData) => tempResource.value == resource.id).isSelected;
                    });
                } else {
                    this.mybResources = myResources.filter((r) => this.participants1[r.id]);
                }

                this.selectedWorkersCount = this.mybResources.length;
            }

            this.isMobileMenu = this.screenSizeService.getScreenWidth() < 575;
        });
    }

    ngOnDestroy(): void {
        this.saveScroll();

        // Disconnect from socket when component is destroyed
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    // function that closes worker selection modal in 1 day mode and returns the selected workers to before this modal was opened
    cancelButton(): void {
        this.isWorkerSelectionOpened = false;
        this.myeResources.forEach((resource: MbscSelectData) => (resource.isSelected = this.temporaryResources.get(resource.value)));
    }

    // function that saves changes in the worker selection
    saveWorkerSelection(): void {
        const tempResources: Worker[] = [];
        myResources.forEach((resource: Resource) => {
            tempResources.push({
                saparId: resource.id,
                saparName: resource.name,
                workerImage: resource.imagePath,
                isShowMobile: this.myeResources.find((tempResource: MbscSelectData) => tempResource.value == resource.id).isSelected,
            });
        });
        console.log(tempResources);
        this.httpService.setWorkersMobile(tempResources);

        this.mybResources = myResources.filter((resource: Resource) => {
            return this.myeResources.find((tempResource: MbscSelectData) => tempResource.value == resource.id).isSelected;
        });

        this.selectedWorkersCount = this.mybResources.length;
        this.isWorkerSelectionOpened = false;
    }

    // function that closes datepicker
    closeDatepicker(): void {
        this.mobileDatepicker.close();
        this.desktopDatepicker.close();
    }

    isDisabled(id: number): boolean {
        console.log(this.controls);
        if (this.controls) {
            let control = this.controls.find((control) => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    // function that opens a mode selection modal
    openModeSelectMenu(): void {
        this.isModeSelectOpened = true;
    }

    // function that opens menu on mobile resolution
    openCalendarMenu(): void {
        this.isCalendarMenuOpened = true;
    }

    // function that opens a worker selection modal in 1 day mode
    openWorkerSelection(): void {
        const selectedResourcesCount: number = this.myeResources.filter((resource: MbscSelectData) => resource.isSelected).length;

        this.isSelectedWorkersOverLimit = selectedResourcesCount > 7;
        this.isNotSelectedWorkers = selectedResourcesCount == 0;

        this.isWorkerSelectionOpened = true;
        this.myeResources.forEach((resource: MbscSelectData) => this.temporaryResources.set(resource.value, resource.isSelected));
    }

    // function that toggle a worker selection in 4 day and week modes
    toggleWorkerList(): void {
        this.isWorkerListOpened = !this.isWorkerListOpened;
    }

    // function that toggle a worker selection modal in 4 day and week modes
    toggleWorkerListModal(): void {
        this.isWorkerListModalOpened = !this.isWorkerListModalOpened;
    }

    // function that saves worker selection in the modal in 4 day and week modes
    chooseWorker(id: number): void {
        this.resourceId = id;

        this.mybResources.forEach((worker) => (this.participants1[worker.id] = false));
        this.participants1[this.resourceId] = true;
        this.mybResources = myResources.filter((r) => this.participants1[r.id]);

        this.selectedWorkerName = this.myeResources.find((worker) => worker.value == this.resourceId).text;
        this.selectedWorkerImagePath = this.myeResources.find((worker) => worker.value == this.resourceId).imagePath;

        const workerData = this.myeResources.find((worker) => worker.value === id);
        if (workerData) {
            this.diaryStateService.updateSelectedWorker(workerData);
        }

        this.isWorkerListOpened = false;
        this.isWorkerListModalOpened = false;
    }

    // Select worker from the list in 1 day mode
    chooseWorkerFromMultipleList(): void {
        const selectedResourcesCount: number = this.myeResources.filter((resource: MbscSelectData) => resource.isSelected).length;

        this.isSelectedWorkersOverLimit = selectedResourcesCount > 7;
        this.isNotSelectedWorkers = selectedResourcesCount == 0;
    }

    // function that returns whatsapp link
    getWhatsAppLink(phone: string): string {
        if (phone && phone.length == 10) {
            return "https://wa.me/+972" + phone.slice(1);
        }
    }

    // function that opens sms dialog
    openDialog(customerId: number, customerPhone: string): void {
        this.isDialogVisible = true;
        this.currentCustomerId = customerId;
        this.currentCustomerPhone = customerPhone;

        this.infoCardPopup.close();

        setTimeout(() => {
            this.smsInput.nativeElement.focus();
        }, 50);
    }

    // function that hides sms dialog
    hideDialog(isSubmited: boolean): void {
        if (isSubmited) {
            if (this.smsText.trim() != "") {
                this.isDialogErrorVisible = false;
                this.isDialogVisible = false;
                this.sendsmsClient(this.currentCustomerId, this.currentCustomerPhone, this.smsText);
                this.smsText = "";
            } else {
                this.isDialogErrorVisible = true;
            }
        } else {
            this.isDialogErrorVisible = false;
            this.isDialogVisible = false;
            this.smsText = "";
        }
    }

    // function that sends sms to client
    sendsmsClient(customerId: number, customerPhone: string, smsText: string) {
        this.sms.businessEmail = sessionStorage.getItem("email");
        this.sms.customerId = customerId;
        this.sms.pelephone = customerPhone;
        this.sms.txtMessage = smsText;

        console.log(this.sms);
        this.httpService1.SendMessageClient(this.sms).then(
            (res: SmsForClient) => {
                this.receivedsms = res;
                console.log(this.receivedsms);
                // this.receivedsms = res.responceMessage;
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );
    }

    // commands for menu items
    menuItemCommand(menuId: number, orderId: number): void {
        if (menuId == 7) {
            if (orderId == 1) {
            } else if (orderId == 2) {
                this.view = "day";
                this.selectedDate = this.selectedMenuDate;
                this.changeView();
            } else if (orderId == 3) {
                this.view = "week";
                this.selectedDate = this.selectedMenuDate;
                this.changeView();
                setTimeout(() => {
                    this.resourceId = this.selectedMenuWorker.id;
                    this.filterDataResource();
                }, 0);
            } else if (orderId == 4) {
                this.view = "4days";
                this.selectedDate = this.selectedMenuDate;
                this.changeView();
                setTimeout(() => {
                    this.resourceId = this.selectedMenuWorker.id;
                    this.filterDataResource();
                }, 0);
            } else if (orderId == 5) {
            }

            this.isCalendarHeaderMenuOpened = false;
        }
    }

    // Change the view of the calendar
    changeView(isLoadingEvents: boolean = true, resetSelectedDate: boolean = true): void {
        this.diaryStateService.updateViewType(this.view);

        setTimeout(() => {
            if (resetSelectedDate) {
                this.selectedDate = new Date();
                (this.selectedDate as Date).setHours(new Date().getHours());
            }

            switch (this.view) {
                case "day": {
                    if (myResources.length) {
                        if (this.screenSizeService.getScreenWidth() <= 991) {
                            this.mybResources = myResources.filter((resource: Resource) => {
                                return this.myeResources.find((tempResource: MbscSelectData) => tempResource.value == resource.id).isSelected;
                            });

                            this.selectedWorkersCount = this.mybResources.length;
                        } else {
                            this.mybResources = myResources;
                        }
                    }

                    this.calView = calViewDayDefault;
                    this.modeSelectItemSelected = 0;
                    break;
                }
                case "4days": {
                    if (myResources.length) {
                        this.mybResources = myResources;
                        this.mybResources.forEach((w) => (this.participants1[w.id] = false));
                        this.participants1[this.mybResources[0].id] = true;
                        this.mybResources = myResources.filter((r) => this.participants1[r.id]);

                        if (resetSelectedDate) {
                            this.resourceId = myResources[0].id;
                            this.selectedWorkerName = this.myeResources.find((worker) => worker.value == this.resourceId).text;
                            this.selectedWorkerImagePath = this.myeResources.find((worker) => worker.value == this.resourceId).imagePath;
                        }
                    }

                    this.dw = 3;
                    this.refDate = this.selectedDate;
                    this.calView = calView4DaysDefault;
                    this.modeSelectItemSelected = 1;
                    break;
                }
                case "week": {
                    if (myResources.length) {
                        this.mybResources = myResources;
                        this.mybResources.forEach((w) => (this.participants1[w.id] = false)); //?
                        this.participants1[this.mybResources[0].id] = true;
                        this.mybResources = myResources.filter((r) => this.participants1[r.id]);

                        if (resetSelectedDate) {
                            this.resourceId = myResources[0].id;
                            this.selectedWorkerName = this.myeResources.find((worker) => worker.value == this.resourceId).text;
                            this.selectedWorkerImagePath = this.myeResources.find((worker) => worker.value == this.resourceId).imagePath;
                        }
                    }

                    this.dw = 6;
                    this.calView = calViewWeekDefault;
                    this.modeSelectItemSelected = 2;
                    break;
                }
            }

            this.updateFirstMenuItems(this.view);

            if (isLoadingEvents) {
                // Use Date instead of string
                this.handleClickAppointmentsSupplemented(this.toNativeDate(this.selectedDate));
            }

            // Removed string builder to use Date as parameter instead of string
            this.buildRange(this.selectedDate);
            this.toggleAllDay();
        }, 0);
    }

    // Change first menu items according to the selected view
    updateFirstMenuItems(view: "day" | "4days" | "week"): void {
        if (this.items.length) {
            if (view == "day") {
                this.items_1 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.SeventhMenu && item.id != "34");
            } else if (view == "4days") {
                this.items_1 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.SeventhMenu && item.id != "30");
            } else if (view == "week") {
                this.items_1 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.SeventhMenu && item.id != "29");
            }
        }
    }

    // function that returns data for calendar
    getData(): OptEvent[] {
        if (this.OptData.length) {
            return this.OptData;
        }
    }

    // Obtain employee data
    getResources(): void {
        this.httpService.getWorkers().subscribe(
            (data: Worker[]) => {
                myResources.splice(0);
                console.log(data);

                data.forEach((worker: Worker) => {
                    myResources.push({
                        id: worker.saparId,
                        name: worker.saparName,
                        depth: 0,
                        isParent: false,
                        description: "ספר",
                        imagePath: worker.workerImage,
                        isShowMobile: worker.isShowMobile,
                    });
                });
                console.log("count of myResources: " + myResources.length);
                console.log(myResources);

                this.mybResources = myResources;
                this.myeResources = myResources.map((item: Resource) => ({
                    text: item.name,
                    value: item.id,
                    imagePath: item.imagePath,
                    isSelected: item.isShowMobile,
                }));
                console.log(this.myeResources);

                if (this.screenSizeService.getScreenWidth() <= 991) {
                    this.mybResources = myResources.filter((resource: Resource) => {
                        return this.myeResources.find((tempResource: MbscSelectData) => tempResource.value == resource.id).isSelected;
                    });

                    this.selectedWorkersCount = this.mybResources.length;
                }

                this.changeView(false, false);
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );
    }

    // function that returns worker image
    getWorkerImage(imagePath: any): string {
        return "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/team/" + imagePath;
    }

    // Toggle the popup menu and close the others
    toggleMenu(event: PointerEvent, menu: Menu, isMobile: boolean, additionalInfo?: Resource | { date: Date }): void {
        if ((additionalInfo as Resource).id != undefined) {
            this.selectedMenuWorker = additionalInfo as Resource;
        } else {
            this.selectedMenuDate = (additionalInfo as { date: Date }).date;
            this.selectedMenuWorker = myResources.find((resource: Resource) => resource.id == this.resourceId);
        }

        if (isMobile) {
            this.isCalendarHeaderMenuOpened = true;
        } else {
            menu.toggle(event);

            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }

            this.openedMenu = menu;
        }
    }

    // Returns the formatted date
    getFormattedRange(start: any, end: any): string {
        return (
            formatDate("MMM D", new Date(start)) + " - " + formatDate("MMM D", new Date(end))

            // formatDate('MMM D', new Date(start)) +
            // (end && this.getNrDays(start, end) > 1 ? ' - ' + formatDate('MMM D', new Date(end)) : '')
        );
    }

    // Get Moment object from different types of date input
    private toMoment(value: Date | MbscDateType | string): moment.Moment {
        const momentDate: moment.Moment = moment(value);

        return momentDate.isValid() ? momentDate : moment(this.selectedDate as Date);
    }

    // Get Date object from different types of date input
    private toNativeDate(value: Date | MbscDateType | string): Date {
        return this.toMoment(value).toDate();
    }

    // Convert date to string in the format required by the API
    private toApiDate(value: Date | MbscDateType | string, format: string = "YYYY-MM-DD"): string {
        return this.toMoment(value).format(format);
    }

    // Get the date for which events should be fetched based on the event data
    private getSocketEventDate(payload: any): Date {
        if (payload && payload.eventDate) {
            return this.toNativeDate(payload.eventDate);
        }

        if (payload && payload.newItem && payload.newItem.start) {
            return this.toNativeDate(payload.newItem.start);
        }

        if (payload && payload.start) {
            return this.toNativeDate(payload.start);
        }

        if (payload) {
            return this.toNativeDate(payload);
        }

        return this.toNativeDate(this.selectedDate);
    }

    // Get appointments
    handleClickAppointments(): void {
        setTimeout(() => {
            // Implement new logic for determining the date range to fetch appointments using moment.js

            const weeksCount: number = 1;
            const baseDate: moment.Moment = this.toMoment(this.selectedDate);
            const startDate: Date = baseDate
                .clone()
                .subtract(weeksCount * beforeafterdays, "days")
                .toDate();
            const endDate: Date = baseDate
                .clone()
                .add(weeksCount * beforeafterdays, "days")
                .toDate();

            const appointmentIn: AppointmentIn = new AppointmentIn();
            appointmentIn.dateVisitFrom = this.toApiDate(startDate); // "2024-06-18"
            appointmentIn.dateVisitTo = this.toApiDate(endDate); // "2024-07-05"
            appointmentIn.dateVisitFrom_1 = "0";
            appointmentIn.dateVisitTo_1 = "0";
            appointmentIn.smsSendingResult = 0;

            const startOfWeek: Date = this.toMoment(this.selectedDate).startOf("week").toDate();
            const endOfWeek: Date = this.toMoment(this.selectedDate).endOf("week").toDate();

            this.rangeText = this.getFormattedRange(startOfWeek, endOfWeek);

            this.rangeValue = [appointmentIn.dateVisitFrom, appointmentIn.dateVisitTo];

            // Get appointments data on init
            this.getAppointmentsSubscription = this.httpService.getAppointmentsCachebyPost(appointmentIn).subscribe((data: Appointment[]) => {
                console.log(data.filter((x) => x.offTimeType));
                this.appointments_opt = data;
                // console.log(data.filter((x) => x.subexp.length > 0));
                console.log("Count of appointmens:" + this.appointments_opt.length);

                this.createFinalArray(true);
                console.log("final array size: " + this.OptData.length);

                // Get invalid time
                this.httpService.getInvalidTime(appointmentIn).subscribe((data: InvalidResourceTime[]) => {
                    this.invalid = data as InvalidResourceTime[];
                    console.log("Count of invalid time:" + this.invalid.length);
                    console.log(this.invalid);

                    this.state = "loaded";

                    setTimeout(() => {
                        this.restoreScroll();
                    }, 0);
                });

                let dates = [];
                this.datepickerLabels = [];
                this.OptData.forEach((x) => {
                    if (x.holidayName && !dates.includes(new Date(x.start as string).getDate())) {
                        dates.push(new Date(x.start as string).getDate());
                        this.datepickerLabels.push({
                            date: x.start,
                            cellCssClass: "holiday-day",
                            text: x.holidayName,
                        } as unknown as MbscCalendarLabel);
                    }

                    x.isBirthday = x.birthDay && x.birthMonth && (this.selectedDate as Date).getDate() == x.birthDay && (this.selectedDate as Date).getMonth() + 1 == x.birthMonth;
                });

                for (const event of this.OptData) {
                    // Convert dates to date objects
                    event.start = event.start ? new Date(event.start as string) : event.start;
                    event.end = event.end ? new Date(event.end as string) : event.end;
                    // Mark past events as fixed by setting the event.editable property to false
                    event.editable = !!(event.start && today < event.start);
                }

                this.toggleAllDay();
            });

            // Removed string builder to use Date as parameter instead of string
            this.buildRange(this.selectedDate);
        }, 0);
    }

    //mapping data for binding to component elements
    createFinalArray(step: boolean): void {
        if (step) {
            this.appointments_opt.map((s1) => {
                this.OptData.push({
                    id: s1.yomanId,
                    start: s1.fromTime,
                    end: s1.toTime,
                    resource: s1.saparId,
                    title: s1.firstName,
                    job: s1.shortName,
                    color: s1.bColor,
                    holidayName: s1.holidayName,
                    firstName: s1.firstName,
                    customerId: s1.customerId,
                    isOffDay: s1.isOffDay,
                    phoneNum2: s1.phoneNum2,
                    transactId: s1.transactId,
                    hasComments: s1.hasComments,
                    resourceStream: s1.resourceStream,
                    statusCall: s1.statusCall,
                    statusQueue: s1.statusQueue,
                    birthDay: s1.birthDay,
                    birthMonth: s1.birthMonth,
                    confStatus: s1.confStatus,
                    allDay: s1.allDay,
                    editable: s1.editable,
                    prepayStatus: s1.prepayStatus,
                    statusAppointment: s1.statusAppointment,
                    isRepeatAppointment: s1.isRepeatAppointment,
                    isCustIcon: s1.isCustIcon,
                    isExtAppId: s1.isExtAppId,
                    con: s1.con,
                    subexp: s1.subexp,
                    iPath: s1.iPath,
                    debt: s1.debt,
                    statusVal: s1.statusVal,
                    offTimeType: s1.offTimeType,
                    isManyApp: s1.isManyApp,
                });
            });
        } else {
            this.OptData_Supplemented = [];
            this.appointments_opt.map((s1) => {
                this.OptData_Supplemented.push({
                    id: s1.yomanId,
                    start: s1.fromTime,
                    end: s1.toTime,
                    resource: s1.saparId,
                    title: s1.firstName,
                    job: s1.shortName,
                    color: s1.bColor,
                    holidayName: s1.holidayName,
                    firstName: s1.firstName,
                    customerId: s1.customerId,
                    isOffDay: s1.isOffDay,
                    phoneNum2: s1.phoneNum2,
                    transactId: s1.transactId,
                    hasComments: s1.hasComments,
                    resourceStream: s1.resourceStream,
                    statusCall: s1.statusCall,
                    statusQueue: s1.statusQueue,
                    birthDay: s1.birthDay,
                    birthMonth: s1.birthMonth,
                    confStatus: s1.confStatus,
                    allDay: s1.allDay,
                    editable: s1.editable,
                    prepayStatus: s1.prepayStatus,
                    statusAppointment: s1.statusAppointment,
                    isRepeatAppointment: s1.isRepeatAppointment,
                    isCustIcon: s1.isCustIcon,
                    isExtAppId: s1.isExtAppId,
                    con: s1.con,
                    subexp: s1.subexp,
                    iPath: s1.iPath,
                    debt: s1.debt,
                    statusVal: s1.statusVal,
                    offTimeType: s1.offTimeType,
                    isManyApp: s1.isManyApp,
                });
            });
        }
    }

    // Employee selection for weekly data display
    filterDataResource(): void {
        console.log("worker " + this.resourceId);

        if (this.resourceId) {
            this.mybResources.forEach((worker) => (this.participants1[worker.id] = false));
            this.participants1[this.resourceId] = true;
            this.mybResources = myResources.filter((r) => this.participants1[r.id]);
            this.selectedWorkerName = this.myeResources.find((worker) => worker.value == this.resourceId).text;
            this.selectedWorkerImagePath = this.myeResources.find((worker) => worker.value == this.resourceId).imagePath;
            console.log("resources length " + this.mybResources.length);
        }
    }

    // function that runs when the date changes and the data refresh starts
    onSelectedDateChange(event: MbscSelectedDateChangeEvent): void {
        console.log(event);
        console.log("onSelectedDateChange ");
        // Use the toNativeDate function to convert the event date to a Date object
        const eventDate = this.toNativeDate(event.date);
        console.log("event date " + eventDate);

        this.diaryStateService.updateSelectedDate(eventDate);

        this.handleClickAppointmentsSupplemented(eventDate);
    }

    refreshDate(): void {
        this.state = "loading";
    }

    // function that runs when the datepicker date changes
    onDatepickerChange(): void {
        this.state = "loading";

        this.diaryStateService.updateSelectedDate(this.toNativeDate(this.selectedDate));

        // Use the toNativeDate function to convert the selectedDate to a Date object
        this.handleClickAppointmentsSupplemented(this.toNativeDate(this.selectedDate));

        (this.selectedDate as Date).setHours(new Date().getHours());
        this.refDate = this.selectedDate;
    }

    // create a header for the datepicker
    buildRange(edate: Date | MbscDateType): void {
        const rangeDate: moment.Moment = this.toMoment(edate);

        // Implement new logic for determining the date range to display in the header using moment.js
        // Used curly brackets inside of case statements to create a separate block scope for the variables firstDay and lastDay, because they are declared with const and cannot be redeclared in the same scope
        switch (this.dw) {
            case 6:
                {
                    const firstDay: Date = rangeDate.clone().startOf("week").toDate();
                    const lastDay: Date = rangeDate.clone().startOf("week").add(this.dw, "days").toDate();
                    this.rangeText = this.getFormattedRange(firstDay, lastDay);
                }
                break;

            case 3:
                {
                    const firstDay: Date = rangeDate.clone().startOf("day").toDate();
                    const lastDay: Date = rangeDate.clone().startOf("day").add(this.dw, "days").toDate();
                    this.rangeText = this.getFormattedRange(firstDay, lastDay);
                }
                break;
        }
    }

    // Get appointments to add to the calendar based on the date
    // Change the parameter type to Date and use moment.js
    handleClickAppointmentsSupplemented(eventDate: Date | MbscDateType): void {
        // this.state = "loading";

        setTimeout(() => {
            // Implement new logic for determining the date range to fetch appointments using moment.js

            const weeksCount: number = 1;
            const baseDate: moment.Moment = this.toMoment(eventDate);
            const startDate: Date = baseDate
                .clone()
                .subtract(weeksCount * beforeafterdays, "days")
                .toDate();
            const endDate: Date = baseDate
                .clone()
                .add(weeksCount * beforeafterdays, "days")
                .toDate();

            const appointmentIn: AppointmentIn = new AppointmentIn();
            appointmentIn.dateVisitFrom = this.toApiDate(startDate); // "2024-06-18"
            appointmentIn.dateVisitTo = this.toApiDate(endDate); // "2024-07-05"
            appointmentIn.dateVisitFrom_1 = "0";
            appointmentIn.dateVisitTo_1 = "0";
            appointmentIn.smsSendingResult = 0;

            if (!this.getAppointmentsSubscription.closed) {
                this.getAppointmentsSubscription.unsubscribe();
            }

            this.getAppointmentsSubscription = this.httpService.getAppointmentsCachebyPost(appointmentIn).subscribe((data: Appointment[]) => {
                console.log(data);
                this.appointments_opt = data;
                console.log("Count of appointmens:" + this.appointments_opt.length);

                this.createFinalArray(false);
                console.log("OptData_Supplemented: " + this.OptData_Supplemented.length);

                this.httpService.getInvalidTime(appointmentIn).subscribe((data: InvalidResourceTime[]) => {
                    this.invalid = data as InvalidResourceTime[];
                    console.log("Count of invalid time:" + this.invalid.length);

                    this.state = "loaded";
                });

                for (const event of this.OptData_Supplemented) {
                    event.start = event.start ? new Date(event.start as string) : event.start;
                    event.end = event.end ? new Date(event.end as string) : event.end;
                    event.editable = !!(event.start && today < event.start);
                }

                this.OptData = this.OptData_Supplemented;
                console.log("OptData after adding: " + this.OptData.length);

                let dates = [];
                this.datepickerLabels = [];
                this.OptData.forEach((x) => {
                    if (x.holidayName && !dates.includes(new Date(x.start as string).getDate())) {
                        dates.push(new Date(x.start as string).getDate());
                        this.datepickerLabels.push({
                            date: x.start,
                            cellCssClass: "holiday-day",
                            text: x.holidayName,
                        } as unknown as MbscCalendarLabel);
                    }

                    x.isBirthday = x.birthDay && x.birthMonth && (this.selectedDate as Date).getDate() == x.birthDay && (this.selectedDate as Date).getMonth() + 1 == x.birthMonth;
                });

                this.toggleAllDay();
            });

            this.buildRange(eventDate);
        }, 0);
    }

    // Holiday theme
    toggleAllDay(): void {
        if (this.OptData.find((event: OptEvent) => event.allDay)) {
            this.calView = { schedule: Object.assign(this.calView.schedule, { allDay: true }) };
        } else {
            this.calView = { schedule: Object.assign(this.calView.schedule, { allDay: false }) };
        }

        // if (this.calView.schedule.size == 4) {
        // this.calView = { schedule: Object.assign(this.calView.schedule, { allDay: true, startTime: this.selectedDate }) };
        // console.log(this.calView)
        // }
    }

    // Fills the info card popup form with event data
    loadPopupForm(event: MbscCalendarEvent): void {
        moment.locale("he");
        const start = moment(event.start).format("HH:mm");
        const end = moment(event.end).format("HH:mm");

        this.popupEventTitle = event.title;
        this.infoCardPopupEventDates = start + "-" + end;
        this.infoCardPopupEventDuration = moment(event.end).diff(moment(event.start), "minutes").toString();
        this.infoCardPopupEventDate = moment(event.start).format("dddd DD/MM");
        this.infoCardPopupEventResource = this.mybResources.find((resource: Resource) => resource.id === event.resource)!.name;
        this.infoCardPopupEventAllDay = event.allDay || false;
        this.infoCardPopupEventStatus = event["status"] || "busy";
        this.infoCardPopupIpath = event.iPath;
        console.log(this.infoCardPopupIpath);
    }

    // Fills the edit card popup form with event data when creating an event
    async loadPopupFormNewEvent(event: MbscCalendarEvent): Promise<void> {
        moment.locale("he");

        // this.newCardPopupEventDuration = moment(event.end).diff(moment(event.start), "minutes").toString();
        this.newCardPopupEventDate = moment(event.start).format("DD/MM/YYYY");
        this.newCardPopupEventResource = this.mybResources.find((resource: Resource) => resource.id === event.resource)!.id;

        this.newAppData = new AppointmentData();

        this.newAppData.resourceId = this.newCardPopupEventResource;
        this.newAppData.eventDate = this.newCardPopupEventDate;
        this.newAppData.start = event.start;
        this.newAppData.end = event.end;
        this.newAppData.subserv = [];
        // this.newAppData.eventDuration = this.newCardPopupEventDuration;
        this.newAppData.forceCreateCustomer = this.configDiary.forceCreateCustomer;
        this.newAppData.isMustMadeAppoinment = this.configDiary.isMustMadeAppoinment;

        const nextslotin: NextSlotIn = new NextSlotIn();
        nextslotin.saparId = this.newAppData.resourceId;
        nextslotin.startEvent = moment(this.newAppData.start).format("MM/DD/YYYY, HH:mm");

        await this.httpService
            .getStartNextSlot(nextslotin)
            .pipe(take(1))
            .toPromise()
            .then((data: string) => {
                this.newAppData.maxEventEndTime = data;
            });

        this.generateInvalidTime(moment(event.start).toDate());

        //  this.newAppData.maxEventEndTime = "2025-02-17T22:00";

        const tempItem: OptEvent = this.OptData.find((item: OptEvent) => (item.start as Date) && (item.start as Date).toDateString() == (event.start as Date).toDateString() && item.id === -9999);
        if (tempItem) {
            this.newAppDataHoliday = tempItem.holidayName;
        } else {
            this.newAppDataHoliday = "";
        }
    }

    // Fills edit card popup form with event data when editing an event
    async loadPopupFormExistingEvent(event: OptEvent): Promise<void> {
        moment.locale("he");

        this.newAppData = new AppointmentData();

        const nextslotin: NextSlotIn = new NextSlotIn();
        nextslotin.saparId = event.resource as number;
        nextslotin.startEvent = moment(event.start).format("MM/DD/YYYY, HH:mm");

        if (event.customerId != null) {
            await Promise.all([this.httpService.getCustomersAppointmentById({ customer_id: event.customerId }).pipe(take(1)).toPromise(), this.httpService.getServicesByAppointmentId({ yomanId: event.id }).pipe(take(1)).toPromise(), this.httpService.getAppointmentDetailsSummaryStep({ yomanId: event.id }).pipe(take(1)).toPromise(), this.httpService.getStartNextSlot(nextslotin).pipe(take(1)).toPromise()]).then((data: [CustomerAppointment[], Service[], AppointmentDetailsSummaryStep, string]) => {
                this.newAppData.customerapp = data[0][0];
                this.newAppData.subserv = data[1];
                this.newAppData.remark = data[2].comments;
                this.newAppData.appointorId = data[2].madeAppointmentId;
                this.newAppData.creationDate = new Date(data[2].dateVisit);
                this.newAppData.creationAppointorId = data[2].madeAppointmentId;
                this.newAppData.maxEventEndTime = data[3];
                // this.newAppData.maxEventEndTime = "2025-02-17T22:00";

                if (this.newAppData.customerapp) {
                    this.newAppData.customerapp = {
                        ...this.newAppData.customerapp,
                        birthDay: (this.newAppData.customerapp.birthDay as number) < 10 ? "0" + this.newAppData.customerapp.birthDay : this.newAppData.customerapp.birthDay,
                        birthMonth: (this.newAppData.customerapp.birthMonth as number) < 10 ? "0" + this.newAppData.customerapp.birthMonth : this.newAppData.customerapp.birthMonth,
                        isBirthDay: this.newAppData.customerapp.birthDay && this.newAppData.customerapp.birthMonth && moment(event.start).toDate().getDate() == this.newAppData.customerapp.birthDay && moment(event.start).toDate().getMonth() + 1 == this.newAppData.customerapp.birthMonth,
                    };
                }
            });
        } else {
            await Promise.all([this.httpService.getAppointmentDetailsSummaryStep({ yomanId: event.id }).pipe(take(1)).toPromise(), this.httpService.getStartNextSlot(nextslotin).pipe(take(1)).toPromise()]).then((data: [AppointmentDetailsSummaryStep, string]) => {
                this.newAppData.remark = data[0].comments;
                this.newAppData.appointorId = data[0].madeAppointmentId;
                this.newAppData.creationDate = new Date(data[0].dateVisit);
                this.newAppData.creationAppointorId = data[0].madeAppointmentId;
                this.newAppData.maxEventEndTime = data[1];
                // this.newAppData.maxEventEndTime = "2025-02-17T22:00";
            });
        }

        const tempItem: OptEvent = this.OptData.find((item: OptEvent) => (item.start as Date) && (item.start as Date).toDateString() == (event.start as Date).toDateString() && item.id === -9999);
        if (tempItem) {
            this.newAppDataHoliday = tempItem.holidayName;
        } else {
            this.newAppDataHoliday = "";
        }

        console.log(moment(event.start).toDate(), moment(event.end).toDate());

        this.generateInvalidTime(moment(event.start).toDate());

        this.newAppData.absenceId = event.offTimeType;
        this.newAppData.resourceId = this.mybResources.find((resource: Resource) => resource.id === event.resource)!.id;
        this.newAppData.statusId = event.statusAppointment;
        // this.newAppData.eventDuration = moment(event.end).diff(moment(event.start), "minutes").toString();
        this.newAppData.eventDate = moment(event.start).format("DD/MM/YYYY");
        this.newAppData.start = moment(event.start).toDate();
        this.newAppData.end = moment(event.end).toDate();
        this.newAppData.forceCreateCustomer = this.configDiary.forceCreateCustomer;
        this.newAppData.isMustMadeAppoinment = this.configDiary.isMustMadeAppoinment;
        this.newAppData.id = event.id;

        console.log("[calendarview] newAppData.start:", this.newAppData.start);
    }

    // Function that generates invalid time array
    generateInvalidTime(date: Date): void {
        const tempInvalidTime = JSON.parse(
            JSON.stringify(
                this.invalid.filter((item: InvalidResourceTime) => {
                    return moment(item.start).toDate().toDateString() == date.toDateString();
                }),
            ),
        );

        this.OptData.filter((event: OptEvent) => {
            return moment(event.start).toDate().toDateString() == date.toDateString() && moment(event.start).toDate().toISOString() != date.toISOString() && event.id !== -9999;
        }).forEach((event: OptEvent) => {
            tempInvalidTime.push({
                start: moment(event.start).toDate(),
                end: moment(event.end).toDate(),
                resource: event.resource as number,
            });
        });

        tempInvalidTime.sort((a: InvalidResourceTime, b: InvalidResourceTime) => {
            return a.resource - b.resource || moment(a.start).toDate().getTime() - moment(b.start).toDate().getTime();
        });

        tempInvalidTime.forEach((item: InvalidResourceTime) => {
            item.start = moment(item.start).format("HH:mm");
            item.end = moment(item.end).format("HH:mm");
        });

        if (tempInvalidTime.length) {
            this.newCardPopupEventInvalidTime = [tempInvalidTime[0]];

            for (let i = 1; i < tempInvalidTime.length; i++) {
                const last = this.newCardPopupEventInvalidTime[this.newCardPopupEventInvalidTime.length - 1];
                const current = tempInvalidTime[i];

                if (last.end == current.start) {
                    last.end = current.end;
                } else {
                    this.newCardPopupEventInvalidTime.push(current);
                }
            }
        } else {
            this.newCardPopupEventInvalidTime = [];
        }

        console.log(this.newCardPopupEventInvalidTime);
    }

    // Function that returns client image
    getClientImageSrc(): string {
        return !this.infoCardPopupIpath ? "assets/img/client-avatar.png" : "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + this.infoCardPopupEvent.customerId + "/" + this.infoCardPopupIpath;
    }

    // Delete client image
    clearImagePath(): void {
        this.infoCardPopupIpath = "";
    }

    // Saves event
    saveEvent(): void {
        this.tempEvent.title = this.popupEventTitle;
        this.tempEvent["description"] = this.infoCardPopupEventDescription;
        this.tempEvent.start = this.infoCardPopupEventDates[0];
        this.tempEvent.end = this.infoCardPopupEventDates[1];
        this.tempEvent.allDay = this.infoCardPopupEventAllDay;
        this.tempEvent["status"] = this.infoCardPopupEventStatus;
        this.tempEvent.color = this.selectedColor;

        if (this.isEditingEvent) {
            // update the event in the list
            this.OptData = [...this.OptData];
            // here you can update the event in your storage as well
            // ...
        } else {
            // add the new event to the list
            this.OptData = [...this.OptData, this.tempEvent];
            // here you can add the event to your storage as well
            // ...
        }

        // navigate the calendar
        this.calendar.navigateToEvent(this.tempEvent);
        // close the popup
        this.infoCardPopup.close();
    }

    // Saves created event
    saveNewEvent(): void {
        this.tempEvent.title = this.popupEventTitle;

        if (this.isEditingEvent) {
            // update the event in the list
            this.OptData = [...this.OptData];
            // here you can update the event in your storage as well
            // ...
        } else {
            // add the new event to the list
            this.OptData = [...this.OptData, this.tempEvent];
            // here you can add the event to your storage as well
            // ...
        }
        // navigate the calendar
        this.calendar.navigateToEvent(this.tempEvent);
        // close the popup
        this.newEventPopup.close();
    }

    // Function that closes info card popup
    closeInfoCardPopup(): void {
        // close the popup
        this.infoCardPopup.close();

        this.isEditingEvent = false;
    }

    // Function that closes popup of creating new event
    closeNewEventPopup(): void {
        // close the popup
        this.newEventPopup.close();
    }

    // Function that closes popup of editing event
    closeUpgradeEventPopup(): void {
        // close the popup
        this.popupAnswer.close();
    }

    // not in use yet
    onGetInfoClick(args: MbscCalendarEvent): void {
        let appdetin: AppointmentDetailsIn = new AppointmentDetailsIn();
        appdetin.yomanId = args.id;

        this.httpService.getAppointmentDetails(appdetin).subscribe(
            (data: AppointmentDetails) => {
                this.appdet = data;
                console.log(this.appdet);

                this.infoCardPopupComment = this.appdet.comments;
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
            },
        );
    }

    // Function that works after clicking the finish button in the event creation popup
    addItem(newItem: AppointmentData): void {
        console.log(newItem);

        this.state = "loading";

        this.httpService.setEventNew(newItem).then(
            (data: OptEvent) => {
                // this.OptData = [...this.OptData, data];

                // Use the toNativeDate function to convert the event date to a Date object
                const eventDate = this.toNativeDate(newItem.start);
                console.log("event date " + eventDate);
                if (data !== undefined) {
                    if (data.statusVal !== null) {
                        // this.popupButtons = this.popupUpgradeButtons;
                        // this.statusUpgradeEventText = getEventStatus(data.statusVal!);
                        // this.popupanswer.open();

                        if (data.statusVal == 2 || data.statusVal == 7 || data.statusVal == 10) {
                            this.notify.toast({
                                message: getEventStatus(data.statusVal),
                                color: "success",
                                cssClass: "mbsc-success-toast",
                            });
                        } else {
                            this.answerPopupHeaderText = "שימו לב";
                            this.popupButtons = [];
                            this.statusUpgradeEventText = getEventStatus(data.statusVal!);
                            this.popupAnswer.open();
                        }

                        this.handleClickAppointmentsSupplemented(eventDate);

                        // Update another users calendars when the event is created or updated
                        if (this.configDiary.isISocket) {
                            this.socket.emit("newAppointment", { newItem });
                        }
                    }
                }

                console.log("data length after paste: " + this.OptData.length);
                console.log(data);
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
            },
        );

        this.closeNewEventPopup();
    }

    // Function that opens event editing popup
    async editEvent(): Promise<void> {
        // set popup options
        // this.popupHeaderText = 'עדכון תור קיים';

        this.isEditingEvent = true;

        this.tempEvent = this.selectedEvent[0];
        this.popupAnchor = this.menuAnchor;

        await this.loadPopupFormExistingEvent(this.tempEvent);
        // fill popup form with event data

        console.log(this.tempEvent);
        // Delay initialize so Angular has time to pass updated `newAppData` to the child
        // (avoids child reading stale/default values and resetting times to now).
        setTimeout(() => this.createAppointmentComponent.initialize(), 0);

        // open the popup
        this.newEventPopup.open();
    }

    // Function that copies event
    copyEvents() {
        //if (this.tempEvent!==null || this.tempEvent!==undefined) {
        if (this.selectedEvent !== null || this.selectedEvent !== undefined) {
            this.action = "copy";

            this.copiedEvent = this.selectedEvent;
        }
    }

    // Function that copies event and activates event cutting
    cutEvents() {
        if (this.selectedEvent !== null || this.selectedEvent !== undefined) {
            this.action = "cut";

            this.copiedEvent = this.selectedEvent;
            this.deletedEvent = Object.assign({}, this.selectedEvent);
            this.cutEvent(this.deletedEvent);
        }
    }

    // Function that activates deleting
    deleteEvents() {
        if (this.selectedEvent !== null || this.selectedEvent !== undefined) {
            this.action = "delete";
            this.deletedEvent = Object.assign({}, this.selectedEvent);
            this.deleteEvent(this.deletedEvent);
        }
    }

    // Function that returns month difference between d1 and d2
    monthDiff(d1: Date, d2: Date) {
        return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
    }

    // Function that pastes event
    pasteEvents() {
        if (this.copiedEvent !== null) {
            const event: any = this.copiedEvent;
            const newEvent = Object.assign({}, event);
            const startDate: any = this.pastedstartDate; //16.00   //this.pastedDate; //19
            const endDate: any = this.pastedendDate; //!!! 16.45
            let xD: Date = new Date(startDate);
            let yD: Date = new Date(endDate);

            // const diff = Math.abs(endDate - startDate);//?
            const difference: number = yD.getTime() - xD.getTime();

            //? newEvent.start = startDate.setMonth(startDate.getMonth() - this.monthDiff(this.toDate, this.originDate));
            //? newEvent.end = new Date(startDate.getTime() + diff);

            newEvent.start = this.pastedDate; // .setMonth(startDate.getMonth() - this.monthDiff(this.toDate, this.originDate));
            newEvent.end = new Date(newEvent.start.getTime() + difference);
            newEvent.resource = this.pastedResource;
            newEvent.color = this.pastedColor;
            console.log("data length before paste: " + this.OptData.length);
            //delete newEvent.id;

            if (this.action === "cut") {
                // this.dummy.nativeElement.focus();
            } else {
                // this.notify.toast({
                //     message: 'Event' + (this.selectedEvent !== null || this.selectedEvent !== undefined ? '' : 's') + ' pasted',
                // });
            }
            if (this.action === "copy" || this.action === "cut") {
                this.copiedEvent = null;
                this.selectedEvent = null;
            }

            let yomanidtmp = event[0].id;

            this.appUpIn.action = this.action;
            const options: any = {
                hour12: false,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            };

            // toLocaleString is unreliable here: its output can vary by device and locale,
            // so use explicit formatting (moment) to produce a stable MM/DD/YYYY, HH:mm string.

            // let startev = newEvent.start.toLocaleString("il-IL", options);
            // let endev = newEvent.end.toLocaleString("il-IL", options);

            // let startev = moment(newEvent.start).format("MM/DD/YYYY, HH:mm");
            // let endev = moment(newEvent.end).format("MM/DD/YYYY, HH:mm");
            let startev = this.toApiDate(newEvent.start, "MM/DD/YYYY, HH:mm");
            let endev = this.toApiDate(newEvent.end, "MM/DD/YYYY, HH:mm");

            this.appUpIn.dateVisitFrom = startev;
            this.appUpIn.resource = newEvent.resource;
            this.appUpIn.dateVisitTo = endev;
            this.appUpIn.yomanId = yomanidtmp;

            //This needs to be removed after receiving data from the service

            //       this.OptData = [...this.OptData, newEvent];
            //       console.log("data length after paste: " + this.OptData.length)

            this.state = "loading";

            this.httpService.setEventCopyCutDel(this.appUpIn).then(
                (data: OptEvent) => {
                    // this.OptData = [...this.OptData, data];

                    // Use the toNativeDate function to convert the event date to a Date object
                    const eventDate = this.toNativeDate(newEvent.start);
                    console.log("event date " + eventDate);
                    if (data !== undefined) {
                        if (data.statusVal !== null) {
                            if (data.statusVal == 2 || data.statusVal == 7 || data.statusVal == 10 || data.statusVal == 19 || data.statusVal == 20 || data.statusVal == 21 || data.statusVal == 29 || data.statusVal == 25 || data.statusVal == 26) {
                                // this.showMessage("success", getEventStatus(data.statusVal));
                                this.notify.toast({
                                    message: getEventStatus(data.statusVal),
                                    color: "success",
                                    cssClass: "mbsc-success-toast",
                                });
                            } else {
                                this.answerPopupHeaderText = "שימו לב";
                                this.popupButtons = [];
                                this.statusUpgradeEventText = getEventStatus(data.statusVal!);
                                this.popupAnswer.open();
                            }
                            this.handleClickAppointmentsSupplemented(eventDate);

                            // Update another users calendars when the event is pasted
                            if (this.configDiary.isISocket) {
                                this.socket.emit("pasteAppointment", { eventDate });
                            }
                        }
                    }

                    console.log("data length after paste: " + this.OptData.length);
                    console.log(data);
                },
                (error) => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
                },
            );
        }
    }

    // Function that opens event deleting popup
    deleteEvent(event: OptEvent): void {
        console.log(event);
        this.clickDel = true;
        this.answerPopupHeaderText = "מחיקת תור";

        this.reasonCancellationEv = this.absenceData[0].text;
        this.isRemovingAdditionalApp = false;

        if (event[0].offTimeType !== null) {
            this.isAbsenceEvent = true;
            this.answerPopupHeaderText = "מחיקת זמן אישי / חופש";
        }
        if (event[0].isManyApp) {
            this.isManyEvCustomer = true;
        }
        this.popupButtons = [];

        this.popupAnswer.open();

        // here you can delete the event from your storage as well
        // ...

        console.log("data length after delete: " + this.OptData.length);
    }

    // Function that cuts event from OptData
    cutEvent(event: OptEvent): void {
        this.OptData = this.OptData.filter((item) => item.id !== event[0].id);
        console.log("data length after cut: " + this.OptData.length);
    }

    // Function that opens the confirmation popup for deleting event
    confirmDeleteApp(): void {
        this.isAnswerConfirmPopupVisible = true;
        this.popupAnswer.close();
    }

    // Function that closes the deleting popup
    closeAnswerPopup(): void {
        this.popupAnswer.close();
    }

    // Function that cancels the confirmation of deleting event
    cancelDeleteEventConfirmation(): void {
        this.isAnswerConfirmPopupVisible = false;
    }

    // Funtion that confirms the deleting of event
    confirmDeleteEvent(): void {
        const event: any = this.selectedEvent;
        this.isAnswerConfirmPopupVisible = false;
        this.clickDel = false;

        let yomanidtmp = event[0].id;
        this.appUpIn.action = this.action;
        const options: any = {
            hour12: false,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        };

        // toLocaleString is unreliable here: its output can vary by device and locale,
        // so use explicit formatting (moment) to produce a stable MM/DD/YYYY, HH:mm string.

        // let startev = event[0].start.toLocaleString("il-IL", options);
        // let endev = event[0].end.toLocaleString("il-IL", options);

        // let startev = moment(event[0].start).format("MM/DD/YYYY, HH:mm");
        // let endev = moment(event[0].end).format("MM/DD/YYYY, HH:mm");
        let startev = this.toApiDate(event[0].start, "MM/DD/YYYY, HH:mm");
        let endev = this.toApiDate(event[0].end, "MM/DD/YYYY, HH:mm");

        let reasonCancellation = this.absenceData.find((item) => item.text == this.reasonCancellationEv);

        this.appUpIn.dateVisitFrom = startev;
        this.appUpIn.resource = event[0].resource;
        this.appUpIn.dateVisitTo = endev;
        this.appUpIn.yomanId = yomanidtmp;
        this.appUpIn.removeAdditionalApp = this.isRemovingAdditionalApp;
        this.appUpIn.reasonCancellation = { text: reasonCancellation.text, value: reasonCancellation.value };

        //This needs to be removed after receiving data from the service

        //       this.OptData = [...this.OptData, newEvent];
        //       console.log("data length after paste: " + this.OptData.length)

        this.state = "loading";

        this.httpService.setEventCopyCutDel(this.appUpIn).then(
            (data: OptEvent) => {
                // this.OptData = [...this.OptData, data];

                // Use the toNativeDate function to convert the event date to a Date object
                const eventDate = this.toNativeDate(event[0].start);
                console.log("event date " + eventDate);
                if (data !== undefined) {
                    if (data.statusVal !== null) {
                        if (data.statusVal == 19 || data.statusVal == 20 || data.statusVal == 21) {
                            // this.showMessage("success", getEventStatus(data.statusVal));
                            this.notify.toast({
                                message: getEventStatus(data.statusVal),
                                color: "success",
                                cssClass: "mbsc-success-toast",
                            });
                        } else {
                            this.answerPopupHeaderText = "שימו לב";
                            this.popupButtons = [];
                            this.statusUpgradeEventText = getEventStatus(data.statusVal);
                            this.popupAnswer.open();
                        }
                        this.handleClickAppointmentsSupplemented(eventDate);

                        // Update another users calendars when the event is deleted
                        if (this.configDiary.isISocket) {
                            this.socket.emit("deleteAppointment", { eventDate });
                        }
                    }
                }

                console.log("data length after paste: " + this.OptData.length);
                console.log(data);

                this.OptData = this.OptData.filter((item) => item.id !== this.selectedEvent[0].id);
                this.selectedEvent = null;
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
            },
        );
    }

    // Function that shows messages
    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        } else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            } else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    getFreshData() {
        //  if (isLoadingEvents) {
        this.state = "loading";
        // this.handleClickAppointmentsSupplemented(new Date());
        // Use the toNativeDate function to convert the selectedDate to a Date object instead of using string
        this.handleClickAppointmentsSupplemented(this.toNativeDate(this.selectedDate)); //to return to the date from which the data update was made

        //}
    }

    handleLongPress(event: Event) {
        if (this.screenSizeService.getScreenWidth() > 991) {
            event.preventDefault();
            return;
        }

        this.isLongPressing = true;

        const targetElement: HTMLElement = event.target as HTMLElement;

        // 1. Check for SLOT (free time)
        if (targetElement.closest(".mbsc-schedule-column") && targetElement.closest(".mbsc-schedule-item")) {
            const key: string[] = targetElement.closest(".mbsc-schedule-column").getAttribute("data-key").split("-");

            console.log(this.configDiary);

            const items: HTMLElement[] = Array.from(targetElement.closest(".mbsc-schedule-column").querySelectorAll(".mbsc-schedule-item")) as HTMLElement[];
            const rowIndex: number = items.findIndex((item: HTMLElement) => item === targetElement.closest(".mbsc-schedule-item"));

            const time: string = moment(this.configDiary.fromHour, "HH:mm")
                .add(this.configDiary.calScaleInMin * rowIndex, "minutes")
                .format("HH:mm");

            const date: Date = moment({
                year: +key[0],
                month: +key[1] - 1,
                day: +key[2],
                hour: +time.split(":")[0],
                minute: +time.split(":")[1],
            }).toDate();
            const resource: number = +key[3];

            if (!this.menuOpen && this.copiedEvent !== undefined && this.copiedEvent !== null) {
                event.preventDefault();
                this.menuData = disabledMenu;
                this.isMenuDisabled = true;
                this.menuAnchor = targetElement;
                this.pastedDate = date;
                this.pastedResource = resource;

                setTimeout(() => {
                    this.menuRight.open();
                });
            }
        }
        // 2. Check for EVENT
        else if (targetElement.closest(".mbsc-schedule-event")) {
            const eventId: number = +targetElement.closest(".mbsc-schedule-event").getAttribute("data-id");

            const targetEvent: MbscCalendarEvent = this.OptData.find((event: MbscCalendarEvent) => event.id === eventId);

            this.selectedEvent = [targetEvent];

            this.pastedendDate = [targetEvent.end];
            this.pastedstartDate = [targetEvent.start];
            let stc = [targetEvent.color];
            this.pastedColor = stc.toString();

            event.preventDefault();
            this.menuData = menuData;
            this.isMenuDisabled = false;
            this.menuAnchor = targetElement.closest(".mbsc-schedule-event");
            setTimeout(() => {
                this.menuRight.open();
            });
            this.clickDel = false;
            this.isManyEvCustomer = false;
            this.isAbsenceEvent = false;
            this.menuOpen = true;
        }

        setTimeout(() => {
            this.isLongPressing = false;
        });
    }

    //saving the calendar state
    saveScroll(): void {
        const scrollElement: HTMLElement | null = document.querySelector(".mbsc-schedule-grid-scroll") as HTMLElement;

        if (scrollElement) {
            this.savedScroll = scrollElement.scrollTop;
            this.diaryStateService.updateDatepickerScrollTop(this.savedScroll);
            console.log("SAVE", this.savedScroll);
        }
    }

    //restoring the calendar state
    restoreScroll(): void {
        const scrollElement: HTMLElement | null = document.querySelector(".mbsc-schedule-grid-scroll") as HTMLElement;

        if (scrollElement) {
            this.savedScroll = this.diaryStateService.datepickerScrollTop;
            console.log("RESTORE", this.savedScroll);

            scrollElement.scrollTop = this.savedScroll;
        }
    }
}
